import { IPublisherNames } from '~/src/dash/api/publishers/publishers_models';
import { createUrl, restGet } from '~/src/dash/api/rest';

export async function getPublishersNames(
  publisherID: string,
  query: string,
): Promise<[IPublisherNames[] | undefined, string | undefined]> {
  const reqUrl = createUrl('/publishers_names', publisherID) + '&query=' + query;

  try {
    return [(await restGet<IPublisherNames[]>(reqUrl)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}
